export default "__VITE_ASSET__caec5bc2__"